import { Checkbox, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { OptionEntity } from 'domain/entities/OptionEntity';
import React from 'react';
import getMessage from 'utilities/constants/MESSAGE';

export interface CheckBoxProps {
    options: OptionEntity[];
    name: string;
    required?: boolean;
    requiredMessage?: string;
    rules?: Rule[];
    label?: string;
    labelClassName?: string;
    onChange?: (value: any) => void;
    showErrorMessage?: boolean;
    disabled?: boolean;
    className?: string;
    defaultValue?: any;
}

export const FormCheckBox = ({
    disabled,
    options,
    rules = [],
    label,
    required,
    requiredMessage = getMessage('In_Required', label),
    labelClassName = '',
    name,
    showErrorMessage = true,
    className,
    defaultValue,
    onChange,
}: CheckBoxProps) => {
    const defaultMessage = label ? `${label}を選択してください` : 'この項目は必須項目です';
    const optionsWithRequiredMark = required
        ? options.map((opt) => ({
              ...opt,
              label: (
                  <>
                      {opt.label}
                      <span style={{ color: '#EB5757', marginLeft: 2 }}>*</span>
                  </>
              ),
          }))
        : options;
    return (
        <>
            <Form.Item
                className={className}
                name={name}
                initialValue={defaultValue ? [defaultValue] : []}
                rules={[
                    ...rules,
                    ...(required
                        ? [
                              {
                                  validator: (_: any, value: any) => {
                                      if (!value || value.length === 0) {
                                          return Promise.reject(new Error(defaultMessage));
                                      }
                                      return Promise.resolve();
                                  },
                              } as Rule,
                          ]
                        : []),
                ]}
            >
                <Checkbox.Group
                    onChange={(val) => onChange && onChange(val)}
                    disabled={disabled}
                    options={optionsWithRequiredMark}
                />
            </Form.Item>
        </>
    );
};
